import { useCallback } from "react";

import BoxContainer from "@hl/base-components/lib/BoxContainer";
import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { WEIGHT_BOLD } from "@hl/base-components/lib/theme/typography";
import { ampli } from "@hl/shared-features/lib/ampli";
import {
  Anchor,
  BoxProps,
  Button,
  ButtonProps,
  Group,
  Stack,
  Sx,
  Text,
  Title,
} from "@mantine/core";

import { DisabledCardText } from "../MintPage/MintVector/MintCard";

const DisabledMintBanner = ({
  disabledCardText,
  marketplaceUrl,
  isMarketplaceButton,
  marketplaceButtonProps,
  sx,
  collectionId,
  collectionName,
  ...rest
}: {
  disabledCardText: DisabledCardText;
  marketplaceUrl?: string;
  isMarketplaceButton?: boolean;
  marketplaceButtonProps?: ButtonProps;
  collectionId: string;
  collectionName: string;
  sx?: Sx;
} & BoxProps) => {
  const trackViewOnMarketplace = useCallback(() => {
    if (!ampli.isLoaded) {
      return;
    }
    ampli.viewOnMarketplace({
      collectionId,
      projectName: collectionName,
      marketplace: "Highlight",
      pagePath: window.location.pathname,
    });
  }, [collectionName, collectionId]);

  return (
    <BoxContainer p="12px 16px" sx={sx} {...rest}>
      <Group position="apart">
        <Stack spacing={8}>
          <Title order={6} fw={WEIGHT_BOLD}>
            {disabledCardText.title}
          </Title>
          <Text size="sm" color={TEXT_COLOR.SECONDARY}>
            {disabledCardText.description}
          </Text>
        </Stack>
        {disabledCardText.hasOpenSeaLink &&
          marketplaceUrl &&
          (isMarketplaceButton || marketplaceButtonProps) && (
            <Button
              component="a"
              href={marketplaceUrl}
              target="_blank"
              onClick={trackViewOnMarketplace}
              {...marketplaceButtonProps}
            >
              View on marketplace
            </Button>
          )}{" "}
        {disabledCardText.hasOpenSeaLink &&
          marketplaceUrl &&
          !(isMarketplaceButton || marketplaceButtonProps) && (
            <Anchor
              size="sm"
              fw={500}
              href={marketplaceUrl}
              onClick={trackViewOnMarketplace}
              target="_blank"
            >
              View on marketplace
            </Anchor>
          )}
      </Group>
    </BoxContainer>
  );
};

export default DisabledMintBanner;
